export default __webpack_public_path__ + "static/media/aguilaArpia.261bc027.jpg";